<template>
  <dialog-layout
    :title="title"
    :fullscreen="fullscreen"
    :navIcon="navIcon"
    :dark="dark"
    @pop-dialog="$emit('pop-dialog')"
  >
    <div class="text-center qr-wrapper">
      <canvas ref="qrCanvas" />
      <div class="d-flex ga-1 mt-4 qr-url-row">
        <v-btn
          icon="mdi-content-copy"
          variant="text"
          size="small"
          @click="copyUrl"
          class="flex-shrink-0"
        />
        <p class="text-body-2 text-medium-emphasis my-auto qr-url-text">{{ qrUrl }}</p>
      </div>
    </div>
  </dialog-layout>
</template>

<script>
import QRCode from "qrcode";
import { DialogLayout } from "vue-app-components";

export default {
  name: "dialog-qrcode",
  components: {
    DialogLayout
  },
  props: {
    fullscreen: {
      type: Boolean,
      required: true
    },
    navIcon: {
      type: String,
      required: true
    },
    dark: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    title () {
      return window.location.pathname.includes("/leagues") ? "Join league" : "Join tournament";
    },
    qrUrl () {
      const url = new URL(window.location.href);
      url.searchParams.delete("dialog");
      url.searchParams.delete("tab");
      return url.toString();
    }
  },
  methods: {
    copyUrl () {
      navigator.clipboard.writeText(this.qrUrl).then(() => {
        this.$store.pushSnackbarMessageProps({ message: "Link copied to clipboard." });
      });
    }
  },
  mounted () {
    QRCode.toCanvas(this.$refs.qrCanvas, this.qrUrl, { width: 205 });
  }
};
</script>

<style scoped>
.qr-url-row {
  min-width: 0;
}
.qr-url-text {
  word-break: break-all;
}
@media (max-width: 600px) {
  .qr-wrapper {
    margin-top: calc(50vh - 210px);
  }
}
</style>
